/* @flow */
import * as React from 'react';
import { css, names } from 'linaria';
import { withRouter } from 'react-router';
// import { browserHistory } from 'react-router';

import SiteNavigation from './SiteNavigation';
import HamburgerIcon from './HamburgerIcon';
import Colors from '../../constants/Colors';
import ZIndex from '../../constants/ZIndex';

function Menu({ theme }: { theme: string }) {
  return (
    <div className={names(Styles.Menu, ThemeStyles[theme].Menu)}>
      <div className={names(Styles.TopBorder, ThemeStyles[theme].TopBorder)} />
      <SiteNavigation theme={theme} />
    </div>
  );
}

class MobileNav extends React.Component<
  {
    history: Object,
    theme: string,
    onOpen: () => void,
    onClose: () => void,
  },
  { open: boolean }
> {
  browserHistoryListener: Function;

  state = {
    open: false,
  };

  componentDidMount() {
    let { history } = this.props;
    this.browserHistoryListener = history.listen(() => {
      this.setState({ open: false });
    });
  }

  componentDidUpdate(
    prevProps: $PropertyType<MobileNav, 'props'>,
    prevState: $PropertyType<MobileNav, 'state'>
  ) {
    if (this.state.open !== prevState.open) {
      if (this.state.open) {
        document.body.classList.add('no-scroll');
        this.props.onOpen();
      } else {
        document.body.classList.remove('no-scroll');
        this.props.onClose();
      }
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
    if (this.browserHistoryListener) {
      this.browserHistoryListener();
    }
  }

  _toggle = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  render() {
    let { theme } = this.props;

    return (
      <div className={Styles.Root}>
        <HamburgerIcon
          color={ThemeStyles[theme].HamburgerColor}
          close={this.state.open}
          onClick={this._toggle}
        />
        {this.state.open && <Menu theme={theme} />}
      </div>
    );
  }
}

const ThemeStyles = {
  light: {
    HamburgerColor: Colors.IndigoLight,
    Menu: css`
      background-color: ${Colors.White};
    `,
    TopBorder: css`
      background-color: ${Colors.opacity(Colors.Black, 0.07)};
    `,
  },
  dark: {
    HamburgerColor: Colors.White,
    Menu: css`
      background-color: ${Colors.IndigoDark};
    `,
    TopBorder: css`
      background-color: ${Colors.opacity(Colors.White, 0.07)};
    `,
  },
};

export default withRouter(MobileNav);

const Styles = {
  Root: css`
    display: flex;
    justify-content: flex-end;
    position: relative;
    z-index: ${ZIndex.Highest};
  `,
  Menu: css`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 64px;
  `,
  TopBorder: css`
    height: 1px;
    left: 24px;
    right: 24px;
    position: absolute;
    top: 0;
  `,
};



// WEBPACK FOOTER //
// ./src/ui/components/chrome/MobileNav.js